export default __webpack_public_path__ + "static/media/fridge1-after1.5287f022.jpg";